"use client";

import { useEffect, useState, useCallback } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Autoplay, FreeMode } from "swiper/modules";
import { ChevronLeft, ChevronRight, Maximize2, Pause, Play, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/autoplay";
import "swiper/css/a11y";
interface GalleryPhoto {
  id: number;
  src: string;
  srcset: string;
  sizes: string;
  alt: string;
  caption: string;
  route: string;
}
const transferPhotos: GalleryPhoto[] = [{
  id: 1,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-02-09-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-02-09-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-02-09-1.jpg-wvc-sizes",
  alt: "Man and woman posing with a wheeled suitcase and a Hurghada Transfer Hub welcome sign outside Hurghada Airport Terminal 2",
  caption: "Airport meet and greet",
  route: "Hurghada Airport – Terminal 2"
}, {
  id: 2,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-08-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-08-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-08-1.jpg-wvc-sizes",
  alt: "Family of four with luggage posing with a Hurghada Transfer Hub welcome sign outside a resort entrance",
  caption: "Family arrival pickup",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 3,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-11-2-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-11-2-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-11-2-1.jpg-wvc-sizes",
  alt: "Young man holding a Hurghada Transfer Hub welcome sign in an airport pick-up area with vehicles in the background",
  caption: "Airport pick-up area",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 4,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-24-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-24-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-24-1.jpg-wvc-sizes",
  alt: "Family of four with luggage posing with a Hurghada Transfer Hub welcome sign outside an airport terminal",
  caption: "Family airport pickup",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 5,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-02-19.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-02-19.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-02-19.jpg-wvc-sizes",
  alt: "Three travelers with luggage posing with a Hurghada Transfer Hub welcome sign outside Hurghada International Airport Terminal 1",
  caption: "Airport meet and greet",
  route: "Hurghada Airport – Terminal 1"
}, {
  id: 7,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-11.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-11.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-04-11.jpg-wvc-sizes",
  alt: "Family of three smiling outside an airport terminal entrance, with the son holding a Hurghada Transfer Hub welcome sign and the father giving a thumbs-up",
  caption: "Family arrival pickup",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 8,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-06-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-06-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-06-1.jpg-wvc-sizes",
  alt: "Man and woman with a luggage cart loaded with suitcases, holding a Hurghada Transfer Hub welcome sign outside Hurghada International Airport Terminal 1",
  caption: "Airport meet and greet",
  route: "Hurghada Airport – Terminal 1"
}, {
  id: 9,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-09.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-09.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-09.jpg-wvc-sizes",
  alt: "A large multi-generational family smiling outdoors under a resort garden archway, with one member holding a Hurghada Transfer Hub welcome sign",
  caption: "Family arrival at resort",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 10,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-27-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-27-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-27-1.jpg-wvc-sizes",
  alt: "A smiling traveler standing beside a driver holding a Hurghada Transfer Hub welcome sign, with large rolling suitcases outside an airport terminal",
  caption: "Driver meet and greet",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 11,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-27.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-27.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-06-27.jpg-wvc-sizes",
  alt: "A family seated inside a private passenger transfer van, with the father holding up a white Hurghada Transfer Hub welcome sign next to their luggage",
  caption: "Family van transfer",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 12,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-05.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-05.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-05.jpg-wvc-sizes",
  alt: "A smiling family of three posing outside Hurghada Airport Terminal 2 next to their transfer vehicle, holding a Hurghada Transfer Hub pickup sign",
  caption: "Family airport pickup",
  route: "Hurghada Airport – Terminal 2"
}, {
  id: 13,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-21-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-21-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-21-1.jpg-wvc-sizes",
  alt: "A smiling family of four standing with their luggage in front of a private transfer van, with the father holding a Hurghada Transfer Hub welcome sign",
  caption: "Family arrival pickup",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 14,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-21.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-21.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-07-21.jpg-wvc-sizes",
  alt: "A smiling family of six travelers standing outside Hurghada International Airport Terminal 1 with their rolling luggage, while a young boy holds a Hurghada Transfer Hub welcome sign",
  caption: "Family arrival at Terminal 1",
  route: "Hurghada Airport – Terminal 1"
}, {
  id: 15,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-08-17-1.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-08-17-1.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-08-17-1.jpg-wvc-sizes",
  alt: "A group of travelers posing with their transfer driver and luggage outside Hurghada International Airport Terminal 1, holding a Hurghada Transfer Hub welcome sign",
  caption: "Driver meet and greet",
  route: "Hurghada Airport – Terminal 1"
}, {
  id: 17,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-08-17.jpg",
  srcset: "",
  sizes: "",
  alt: "A Hurghada Transfer Hub representative and a smiling traveler posing together holding a company welcome sign inside a resort shopping arcade",
  caption: "Warm resort welcome",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 18,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-09-14.jpg",
  srcset: "",
  sizes: "",
  alt: "A smiling couple posing at a sunny marina holding a Hurghada Transfer Hub welcome sign with turquoise sea and a boat in the background",
  caption: "Marina pickup",
  route: "Hurghada Transfer Hub Pickup"
}, {
  id: 19,
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1810038/img/2026-09-19.jpg",
  srcset: "",
  sizes: "",
  alt: "Two smiling female travelers posing outside Hurghada International Airport Terminal 1 holding a Hurghada Transfer Hub welcome sign next to their luggage",
  caption: "Friendly airport pickup",
  route: "Hurghada Airport – Terminal 1"
}];
export default function Confidence() {
  const [reduceMotion, setReduceMotion] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [activePhotoIndex, setActivePhotoIndex] = useState<number | null>(null);
  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setReduceMotion(mq.matches);
    const onChange = () => setReduceMotion(mq.matches);
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);
  const openLightbox = (index: number) => {
    setActivePhotoIndex(index);
  };
  const closeLightbox = useCallback(() => {
    setActivePhotoIndex(null);
  }, []);
  const showNextPhoto = useCallback(() => {
    setActivePhotoIndex(prev => prev !== null ? (prev + 1) % transferPhotos.length : 0);
  }, []);
  const showPrevPhoto = useCallback(() => {
    setActivePhotoIndex(prev => prev !== null ? (prev - 1 + transferPhotos.length) % transferPhotos.length : 0);
  }, []);
  useEffect(() => {
    if (activePhotoIndex === null) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowRight") showNextPhoto();
      if (e.key === "ArrowLeft") showPrevPhoto();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [activePhotoIndex, closeLightbox, showNextPhoto, showPrevPhoto]);
  return <section id="travel-with-confidence" data-nav="light" className="bg-secondary text-secondary-foreground py-16 md:py-24 overflow-hidden border-y border-border">
      <div className="mx-auto max-w-[1136px] px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 pb-10">
          <div className="max-w-xl">
            <span className="text-primary font-semibold text-xs tracking-wider uppercase">
              Travel Scenes Across Egypt
            </span>
            <h2 className="mt-2 text-3xl font-bold tracking-tight text-black sm:text-4xl md:text-5xl font-default">
              Travel With Confidence
            </h2>
            <p className="mt-3 text-secondary-foreground/80 text-base md:text-lg">
              Photos from our pickups and transfers.
            </p>
          </div>

          <div className="flex items-center gap-2 self-start md:self-auto">
            <Button variant="outline" size="sm" onClick={() => setIsPaused(prev => !prev)} aria-label={isPaused ? "Resume photo marquee" : "Pause photo marquee"} className="bg-card text-card-foreground border-border hover:bg-accent hover:text-accent-foreground">
              {isPaused ? <>
                  <Play className="size-3.5" />
                  <span className="text-xs">Resume</span>
                </> : <>
                  <Pause className="size-3.5" />
                  <span className="text-xs">Pause</span>
                </>}
            </Button>
          </div>
        </div>
      </div>

      <div className="w-full" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} onTouchStart={() => setIsPaused(true)} onTouchEnd={() => setIsPaused(false)}>
        <Swiper modules={[Autoplay, FreeMode, A11y]} loop={true} speed={4000} freeMode={true} slidesPerView="auto" spaceBetween={20} autoplay={reduceMotion || isPaused ? false : {
        delay: 0,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      }} a11y={{
        prevSlideMessage: "Previous transfer photo",
        nextSlideMessage: "Next transfer photo"
      }} className="!overflow-visible select-none px-6">
          {transferPhotos.map((photo, i) => <SwiperSlide key={photo.id} data-index={i} className="!w-[300px] sm:!w-[380px] md:!w-[420px] shrink-0">
              <div role="button" tabIndex={0} aria-label={`Enlarge transfer photo: ${photo.caption}`} onClick={() => openLightbox(i)} onKeyDown={e => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              openLightbox(i);
            }
          }} className="group relative block aspect-[16/10] w-full overflow-hidden rounded-md border border-border bg-card shadow-xs transition-colors hover:border-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary cursor-pointer text-left">
                <img src={photo.src} data-wvc-srcset={photo.srcset} data-wvc-sizes={photo.sizes} alt={photo.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-102" />

                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent opacity-90 transition-opacity group-hover:opacity-100" />

                <div className="absolute bottom-0 inset-x-0 p-4 text-white">
                  <div className="flex items-center justify-between gap-2">
                    <div>
                      <Link to={"https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(photo.route)} newTab onClick={e => e.stopPropagation()} className="inline-block hover:underline">
                        <p className="text-xs font-semibold tracking-wider text-primary uppercase">
                          {photo.route}
                        </p>
                      </Link>
                      <p className="text-sm font-medium text-white/95 mt-0.5 line-clamp-1">
                        {photo.caption}
                      </p>
                    </div>
                    <span className="flex size-8 shrink-0 items-center justify-center rounded-full bg-black/40 text-white backdrop-blur-xs transition-colors group-hover:bg-primary group-hover:text-primary-foreground">
                      <Maximize2 className="size-4" />
                    </span>
                  </div>
                </div>
              </div>
            </SwiperSlide>)}
        </Swiper>
      </div>

      {activePhotoIndex !== null && <div role="dialog" aria-modal="true" aria-label="Transfer photograph viewer" className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 p-4 backdrop-blur-sm transition-opacity">
          <div className="absolute inset-0 cursor-pointer" onClick={closeLightbox} aria-hidden="true" />

          <div className="relative z-10 flex w-full max-w-4xl flex-col items-center">
            <div className="flex w-full items-center justify-between pb-3 text-white">
              <div>
                <span className="text-xs font-semibold uppercase tracking-wider text-primary">
                  <Link to={"https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(transferPhotos[activePhotoIndex].route)} newTab onClick={e => e.stopPropagation()} className="hover:underline">
                    {transferPhotos[activePhotoIndex].route}
                  </Link>
                </span>
                <p className="text-sm text-white/90">
                  {transferPhotos[activePhotoIndex].caption}
                </p>
              </div>

              <Button variant="outline" size="icon" onClick={closeLightbox} aria-label="Close photo preview" className="bg-card/20 text-white border-white/20 hover:bg-card/40 hover:text-white">
                <X className="size-5" />
              </Button>
            </div>

            <div className="relative aspect-[16/10] w-full overflow-hidden rounded-md border border-white/10 bg-black">
              <img src={transferPhotos[activePhotoIndex].src} data-wvc-srcset={transferPhotos[activePhotoIndex].srcset} data-wvc-sizes={transferPhotos[activePhotoIndex].sizes} alt={transferPhotos[activePhotoIndex].alt} className="h-full w-full object-cover" />
            </div>

            <div className="mt-4 flex w-full items-center justify-between">
              <div className="text-xs text-white/70">
                Photo {activePhotoIndex + 1} of {transferPhotos.length}
              </div>

              <div className="flex gap-2">
                <Button variant="outline" size="sm" onClick={showPrevPhoto} aria-label="Previous photograph" className="bg-card/20 text-white border-white/20 hover:bg-card/40 hover:text-white">
                  <ChevronLeft className="size-4 mr-1" />
                  <span>Previous</span>
                </Button>

                <Button variant="outline" size="sm" onClick={showNextPhoto} aria-label="Next photograph" className="bg-card/20 text-white border-white/20 hover:bg-card/40 hover:text-white">
                  <span>Next</span>
                  <ChevronRight className="size-4 mr-1" />
                </Button>
              </div>
            </div>
          </div>
        </div>}
    </section>;
}